import {connect} from '@store/@common';

import {authUser, userHasFlag} from '@store/auth';
import RepProfilePageActions from 'actions/RepProfilePageActions';
import {RepProfilePageTabs} from './RepProfilePageTabs';

const mapStateToProps = {
  authUser,
  userHasFlag,
};

const mapDispatchToProps = {
  changeDirection: (direction, teamId, repId, startDate, endDate) => {
    RepProfilePageActions.getCoachingActivity({
      direction: direction,
      teamId: teamId,
      userId: repId,
      startDate,
      endDate,
    });
    RepProfilePageActions.getCoachingTeamMetrics({
      direction: direction,
      teamId: teamId,
      userId: repId,
      startDate,
      endDate,
    });
  },
};

export default connect(RepProfilePageTabs, mapStateToProps, mapDispatchToProps);
